export const CHAT = 'chat';
export const PLAIN = 'plain';
export const RANDOM = 'random';
export const THANK = 'thank';
